<template>
    <div id="main">
        <loader v-if="isLoading" />
        <alert-container :messages="msgs" />
        <div class="listing-header mb-3">
            <div class="title-breadcrumb">
                <h1 class="title">
                    {{ $t('vincular-usuario') }}
                    <a class="pl-1" v-if="hide.hideInfo" @click="infoIsHidden()">
                        <b-icon v-if="!hide.infoIsHidden" icon="eye-off-outline" type="is-danger" />
                        <b-icon v-if="hide.infoIsHidden" icon="eye-outline" type="is-success" />
                    </a>
                </h1>
            </div>
            <div class="header-buttons">
                <button class="delete-btn" type="button" @click="onFecharModal">
                    {{ $t('cancelar') }}
                </button>

                <button
                    class="save-btn"
                    type="button"
                    @click="save"
                    :disabled="usuariosSelecionados.length === 0"
                >
                    {{ $t('salvar') }}
                </button>
            </div>
        </div>

        <div class="search-and-filter">
            <div class="search-bar">
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-campo-busca-usuario-ass"
                />
            </div>
        </div>

        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="usuarios"
                class="data-table"
                @sort="sortTable"
                backend-sorting
                checkable
                :checked-rows.sync="usuariosSelecionados"
                :custom-is-checked="
                    (selecionados, linha) => selecionados.idusuario == linha.idusuario
                "
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="$t(f.key)"
                    :width="f.width"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <div v-if="f.key == 'nome'">
                        <HideInfo
                            v-if="!cleanHide"
                            :value="props.row[f.key]"
                            :hideInfo="hide.hideInfo"
                            :infoIsHidden="hide.infoIsHidden"
                        />
                    </div>
                    <div v-else-if="f.key == 'login'">
                        <HideInfo
                            v-if="!cleanHide"
                            :value="props.row[f.key]"
                            :hideInfo="hide.hideInfo"
                            :infoIsHidden="hide.infoIsHidden"
                        />
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>

            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
    </div>
</template>

<script>
// SERVICES
import AssTabPrecoUsuarioService from '@/services/vendas/tabpreco/AssTabPrecoUsuarioService';
import Message from '@/models/Message';
import HideInfo from '@/components/shared/HideInfo';
import { mapState } from 'vuex';

export default {
    components: {
        HideInfo,
    },
    props: {
        idTabPreco: 0,
    },
    data() {
        return {
            cleanHide: true,
            service: new AssTabPrecoUsuarioService(this.$http, this.$router),
            usuarios: [],
            isLoading: false,
            isEmpty: false,
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'login', width: null, sortable: true, sortFn: null },
            ],
            usuariosSelecionados: [],
            idusuario: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            column: 'nome',
            order: 'asc',
            msgs: [],
        };
    },
    computed: {
        ...mapState(['hide']),
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.carregarDados();
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch('infoIsHidden', {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        carregarDados(currentPage = 1) {
            console.log('carregarDados');
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1) {
                this.pagination.resetPagination = true;
            }

            this.isLoading = true;

            this.service
                .findNaoAssociados(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.idTabPreco,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.usuarios = value;
                    this.isEmpty = this.usuarios.length === 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os dados.');
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    codigo: m.idusuarioerp,
                    idtabpreco: this.idTabPreco,
                    idusuario: m.idusuario,
                    nome: m.nome,
                    login: m.login,
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        save() {
            if (this.usuariosSelecionados.length > 0) {
                this.isLoading = true;

                // Alter some key in all elements of an array
                let newArrayOfObj = this.usuariosSelecionados.map(
                    ({ codigo: idusuarioerp, ...rest }) => ({ idusuarioerp, ...rest })
                );

                this.service
                    .save(newArrayOfObj)
                    .then((value) => {
                        if (value.content === null) {
                            this.msgs.push(new Message('error', `${value.message}`, true));
                        } else {
                            this.$root.showMessage(
                                'success',
                                'msg-sucesso-ao-adicionar-associacao'
                            );
                            this.$emit('fecharModal', true);
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message('alert', 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            } else {
                this.msgs.push(new Message('error', 'msg-selecione-usuario', true));
                this.isLoading = false;
            }
        },

        onFecharModal() {
            this.$emit('fecharModal', true);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 760px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}
</style>
